<template>


  <div class="menu-container w-100 h-100 d-print-none">
    <b-navbar toggleable="lg" class="col-lg-12 shadow" type="light" id="f-menu">

      <b-container>


        <b-navbar-brand href="#" class="pl-4 ">
          <router-link :to="{name:'Home'}" class="w-100 ">
            <img :src="findAttributeOnSiteInfo('icon')" alt="logo" class="w-100 height-logo rounded">
          </router-link>
        </b-navbar-brand>


        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav class="text-left">
          <b-navbar-nav class="text-center">

            <b-nav-item href="#" class="mt-2">
              <b-btn variant="transparent" class="h1">

                <router-link v-if="$store.getters['User/isAuthenticated']"
                             class="text-decoration-none font-weight-bold "
                             :to="{name:'Dashboard'}">
                  داشبورد
                </router-link>

                <router-link v-else class="text-decoration-none  font-weight-bold" :to="{name:'Dashboard'}">
                  ثبت نام / ورود
                </router-link>


              </b-btn>
            </b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav class="text-center text-dark font-weight-bold">

            <b-nav-item>
              <router-link :to="{name:'Products'}">منو</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link :to="{name:'Home'}">صفحه ی اصلی</router-link>
            </b-nav-item>

          </b-navbar-nav>
        </b-collapse>
      </b-container>

    </b-navbar>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: "Nav4",
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      siteInfos: 'SiteInfo/getSiteInfos'
    }),
    getBaseUrl() {
      return axios.defaults.baseURL.replace('api', '')
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll(event) {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        document.getElementById("f-menu").style.backgroundColor = "rgba(238,235,229,0.81)";
      } else {
        document.getElementById("f-menu").style.backgroundColor = "#fff";
      }
    },
    findAttributeOnSiteInfo(attributeName) {
      const attribute = this.siteInfos.filter(siteInfo => siteInfo.name === attributeName);
      if (attribute.length > 0) {
        return attribute[0].value;
      }
      return false
    }
  },
  async mounted() {
    await this.$store.dispatch('SiteInfo/getSiteInfos')

  }
};
</script>

<style scoped>
.menu-container {
  display: flex;
  flex-direction: row;
}

@media screen and (max-width: 767px) {
  .menu-container {
    justify-content: right;
  }
}

a {
  text-decoration: none;
  color: black !important;
  font-size: 20px !important;
  font-family: 'Avini', 'Vazir', sans-serif !important;
}

a:hover {
  text-decoration: none;
  color: black !important;

}

#f-menu {
  overflow: hidden;
  background-color: #f1f1f1;
  transition: 0.4s;
  position: fixed;
  top: 0;
  z-index: 99;
}

.logo-size {
  width: 80px !important;
}
.height-logo{
  height: 65px ;
}
</style>